// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%275%27 viewBox=%270 0 8 5%27%3E%3Cpath fill=%27%239aa0a6%27 d=%27M0 0h8L4 5z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M3 8.5l3.2 3.2L13 4.8%27 fill=%27none%27 stroke=%27%23fff%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* LMS (training) screens — dark theme matching the pluc.tv design */

.lms-main,
.lms-sidenav,
.lms-topbar {
  font-family: "Inter", -apple-system, "Segoe UI", sans-serif;
  -webkit-font-smoothing: antialiased;
}
.lms-main {
  background: #0b0c0e;
  min-height: 100vh;
  color: #e9eaec;
}
.lms-main input,
.lms-main select,
.lms-main textarea,
.lms-main button {
  font-family: inherit;
  color-scheme: dark;
}

/* Header while on LMS pages */
.topbar.lms-topbar {
  background: #000;
  border-bottom: 1px solid #1c1f23 !important;
}
.lms-topbar .hdr-greet,
.lms-topbar .hdr-logout {
  font-size: 13px !important;
}
.lms-topbar .hdr-greet {
  font-weight: 600;
  margin-right: 1.5rem !important;
}
.lms-topbar .hdr-logout {
  color: #b8bcc1 !important;
  cursor: pointer;
}
.lms-topbar .hdr-logout:hover {
  color: #fff !important;
}

.lms-page {
  padding: 28px 28px 40px;
}

.lms-page-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.lms-title {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  margin: 0;
}

.lms-subtitle {
  font-size: 13px;
  color: #9aa0a6;
  margin: 4px 0 0;
}

.lms-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.lms-label {
  font-family: "JetBrains Mono", "SFMono-Regular", Consolas, monospace;
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #9aa0a6;
}

/* Buttons */
.lms-btn {
  border-radius: 8px;
  padding: 9px 16px;
  font-size: 13px;
  font-weight: 600;
  border: 1px solid #3a3f45;
  background: transparent;
  color: #fff;
  cursor: pointer;
  white-space: nowrap;
  text-decoration: none;
  display: inline-block;
}
.lms-btn:hover { border-color: #6b7178; color: #fff; text-decoration: none; }
.lms-btn-primary { background: #ff4a17; border-color: #ff4a17; }
.lms-btn-primary:hover { background: #ff5f33; border-color: #ff5f33; }
.lms-btn-sm { padding: 5px 12px; font-size: 12px; border-radius: 6px; }
.lms-btn-danger { color: #ff5a5a; border-color: #7a2a2a; }
.lms-btn-danger:hover { color: #ff7a7a; border-color: #a33a3a; }

/* Stat cards */
.lms-stats {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 18px;
}
.lms-stat {
  background: #16181b;
  border: 1px solid #2a2e33;
  border-radius: 12px;
  padding: 18px 18px 16px;
}
.lms-stat-value {
  font-size: 26px;
  font-weight: 700;
  color: #fff;
  margin-top: 6px;
  line-height: 1.2;
}
.lms-stat-sub {
  font-size: 12px;
  color: #9aa0a6;
  margin-top: 4px;
}

.tone-green { color: #34c26b !important; }
.tone-red { color: #ff5a5a !important; }
.tone-amber { color: #f5a524 !important; }
.lms-muted,
.lms-table td.lms-muted { color: #9aa0a6; }

/* Card + table */
.lms-card {
  background: #16181b;
  border: 1px solid #2a2e33;
  border-radius: 12px;
  overflow: hidden;
}
.lms-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  padding: 16px 20px;
  border-bottom: 1px solid #2a2e33;
}
.lms-tabs { display: flex; gap: 4px; flex-wrap: wrap; }
.lms-tab {
  background: transparent;
  border: 0;
  color: #b3b8bd;
  font-size: 13px;
  font-weight: 600;
  padding: 7px 12px;
  border-radius: 6px;
  cursor: pointer;
}
.lms-tab:hover { color: #fff; }
.lms-tab.active { background: #2a2e33; color: #fff; }

.lms-input,
.lms-select {
  background: #0f1113;
  border: 1px solid #2f3439;
  border-radius: 8px;
  color: #fff;
  font-size: 14px;
  padding: 10px 12px;
  width: 100%;
  outline: none;
}
.lms-input:focus,
.lms-select:focus { border-color: #ff4a17; }
.lms-input::placeholder { color: #6b7178; }
.lms-search { max-width: 270px; font-size: 13px; }

.lms-table-wrap { overflow-x: auto; }
.lms-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.lms-table th {
  font-family: "JetBrains Mono", "SFMono-Regular", Consolas, monospace;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #9aa0a6;
  padding: 12px 16px;
  border-bottom: 1px solid #2a2e33;
  white-space: nowrap;
}
.lms-table td {
  padding: 12px 16px;
  border-bottom: 1px solid #22262a;
  color: #e9eaec;
  vertical-align: middle;
  white-space: nowrap;
}
.lms-table tr:last-child td { border-bottom: 0; }
.lms-table tbody tr.clickable { cursor: pointer; }
.lms-table tbody tr.clickable:hover td { background: #1b1e21; }
.lms-table tr.is-cancelled td { color: #7d8288; }
.lms-strong { font-weight: 600; color: #fff; }
.lms-sub { font-size: 11px; color: #8d9399; margin-top: 2px; }
.lms-strike { text-decoration: line-through; color: #7d8288; }
.lms-empty { text-align: center; color: #8d9399; padding: 30px !important; }
.lms-row-actions { display: flex; gap: 8px; }

.lms-card-foot {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 14px 20px;
  border-top: 1px solid #2a2e33;
  font-size: 12px;
  color: #9aa0a6;
}

/* Badges */
.lms-badge {
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 9px;
  border-radius: 999px;
}
.badge-amber { background: #3a2c12; color: #f5a524; }
.badge-green { background: #133222; color: #34c26b; }
.badge-red { background: #3a1719; color: #ff5a5a; }
.badge-grey { background: #2a2e33; color: #d3d6d9; }
.badge-blue { background: #132a40; color: #4ea1ff; }

/* Student / trainer cells */
.lms-person { display: flex; align-items: center; gap: 12px; }
.lms-avatar {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  flex-shrink: 0;
  border: 1px solid #3a3f45;
  background: repeating-linear-gradient(135deg, #22262a 0 4px, #2e3338 4px 8px);
}
.lms-bar { display: flex; align-items: center; gap: 10px; }
.lms-bar-track { width: 74px; height: 5px; border-radius: 3px; background: #2a2e33; overflow: hidden; }
.lms-bar-fill { height: 100%; border-radius: 3px; }

/* Create class form */
.lms-form-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 310px;
  gap: 18px;
  align-items: start;
}
.lms-form-card { padding: 22px; }
.lms-form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
}
.lms-form-row-3 { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.lms-field .lms-label { display: block; margin: 0 0 8px; font-weight: 500; color: #9aa0a6; }
.lms-divider { border-top: 1px solid #2a2e33; margin: 20px 0; }
.lms-seg { display: flex; gap: 8px; flex-wrap: wrap; }
.lms-seg .lms-btn.active { background: #ff4a17; border-color: #ff4a17; }
.lms-chip-row { display: flex; gap: 8px; flex-wrap: wrap; margin-bottom: 18px; }
.lms-chip {
  background: #2a2e33;
  border: 1px solid #3a3f45;
  border-radius: 999px;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  padding: 6px 12px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.lms-chip button { background: none; border: 0; color: #9aa0a6; padding: 0; cursor: pointer; }
.lms-chip-add { background: transparent; color: #d3d6d9; cursor: pointer; }
.lms-link { background: none; border: 0; color: #ff5a2e; font-size: 12px; font-weight: 600; cursor: pointer; padding: 0; }
.lms-field-head { display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; }
.lms-selected-box {
  margin-top: 10px;
  border: 1px solid #2f3439;
  border-radius: 8px;
  padding: 12px 14px;
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  font-weight: 600;
}
.lms-side-card { padding: 18px; margin-bottom: 14px; }
.lms-side-card .lms-label { margin-bottom: 12px; display: block; }
.lms-conflict {
  background: #2a2412;
  border: 1px solid #5a4a1c;
  border-radius: 8px;
  padding: 12px;
  font-size: 13px;
  display: flex;
  gap: 10px;
}
.lms-dot { width: 7px; height: 7px; border-radius: 50%; margin-top: 6px; flex-shrink: 0; }
.lms-ok { font-size: 12px; color: #9aa0a6; display: flex; gap: 8px; margin-top: 12px; }
.lms-check { display: flex; align-items: center; gap: 10px; font-size: 13px; font-weight: 400; color: #e9eaec; margin: 0 0 12px; cursor: pointer; }
.lms-check input { width: 18px; height: 18px; margin: 0; accent-color: #ff4a17; }

/* Broadcast */
.lms-textarea { min-height: 120px; resize: vertical; }
.lms-form-grid.lms-broadcast { grid-template-columns: minmax(0, 1fr) 330px; }
.lms-broadcast .lms-chip-row { margin-bottom: 18px; }
.lms-broadcast .lms-chip-add { padding: 9px 14px; }
.lms-broadcast .lms-chip-add.active { background: #ff4a17; border-color: #ff4a17; color: #fff; }
.lms-broadcast .lms-input { padding-top: 11px; padding-bottom: 11px; }
.lms-broadcast-message { min-height: 160px; line-height: 1.7; white-space: pre-wrap; }
.lms-broadcast .lms-cancel-checks .lms-check { font-size: 13px; margin-bottom: 14px; }
.lms-broadcast .lms-check-off span { color: #9aa0a6; }
.lms-broadcast .lms-check.is-disabled { opacity: 0.45; cursor: not-allowed; }
.lms-sending-to {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #2a2e33;
  padding-top: 16px;
  margin-top: 4px;
  font-size: 13px;
  color: #9aa0a6;
}
.lms-recent-row { display: flex; justify-content: space-between; gap: 12px; font-size: 12px; margin-bottom: 10px; }
.lms-recent-row:last-child { margin-bottom: 0; }
.lms-recent-title { color: #e9eaec; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.lms-recent-row .lms-muted { white-space: nowrap; }
.lms-table tr.lms-sent-detail td { white-space: normal; background: #0f1113; }
.lms-sent-message { white-space: pre-line; font-size: 13px; line-height: 1.6; color: #c9ccd0; margin-bottom: 10px; }
@media (max-width: 1200px) {
  .lms-form-grid.lms-broadcast { grid-template-columns: 1fr; }
}

/* Header Admin / LMS switch */
.header-switch {
  display: inline-flex;
  background: #16181b;
  border: 1px solid #2a2e33;
  border-radius: 8px;
  padding: 3px;
  margin-right: 24px;
}
.header-switch a {
  color: #b3b8bd;
  font-size: 13px;
  font-weight: 600;
  padding: 5px 14px;
  border-radius: 6px;
  text-decoration: none;
}
.header-switch a:hover { color: #fff; text-decoration: none; }
.header-switch a.active { background: #ff4a17; color: #fff; }

/* LMS sidebar — overrides the admin sidebar styles from dashboard.css */
.navbar-vertical.navbar-expand-xs.lms-sidenav {
  background-color: #111316;
  border-right: 1px solid #22262a;
}
.lms-sidenav .sidenav-header {
  height: auto;
  padding: 26px 26px 22px;
}
.lms-sidenav .navbar-brand {
  padding: 0;
}
.lms-sidenav .navbar-brand-img {
  max-height: 22px;
  width: auto;
}
.lms-sidenav .navbar-collapse {
  display: block;
}
.lms-sidenav .navbar-nav {
  width: 100%;
  padding: 0;
}
.lms-sidenav.navbar-vertical .navbar-nav > .nav-item {
  margin-bottom: 2px;
}
.lms-sidenav.navbar-vertical.navbar-expand-xs .navbar-nav .nav-link {
  margin: 0 14px;
  padding: 9px 12px;
  font-size: 13px;
  font-weight: 400;
  color: #b8bcc1;
  border-radius: 6px;
  line-height: 1.4;
}
.lms-sidenav.navbar-vertical .navbar-nav .nav-link:hover {
  color: #fff;
  background: #1b1e22;
}
.lms-sidenav.navbar-vertical .navbar-nav > .nav-item .nav-link.active {
  color: #fff !important;
  background: #ff4a17 !important;
  font-weight: 500;
  box-shadow: none;
  border-radius: 6px;
}
.lms-sidenav .nav-link-text {
  margin-left: 0 !important;
}

/* Sidebar section label */
.lms-nav-section {
  font-family: "JetBrains Mono", "SFMono-Regular", Consolas, monospace;
  font-size: 10px;
  letter-spacing: 0.14em;
  color: #6b7178;
  padding: 18px 26px 8px;
  list-style: none;
}

/* Flat main area next to the LMS sidebar (no rounded corner / light gap) */
.main-content.lms-main {
  border-radius: 0;
}
.lms-shell {
  background-color: #0b0c0e;
}

@media (max-width: 1200px) {
  .lms-form-grid { grid-template-columns: 1fr; }
}
@media (max-width: 992px) {
  .lms-stats { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}
@media (max-width: 576px) {
  .lms-page { padding: 18px 16px 30px; }
  .lms-stats { grid-template-columns: 1fr; }
  .lms-form-row { grid-template-columns: 1fr; }
  .lms-search { max-width: none; }
}

/* Refinements to match the design more closely */
.lms-main label {
  margin-left: 0;
  font-size: inherit;
}
.lms-table th:first-child,
.lms-table td:first-child { padding-left: 20px; }
.lms-table th:last-child,
.lms-table td:last-child { padding-right: 20px; }
.lms-table td > .tone-green,
.lms-table td > .tone-red,
.lms-table td > .tone-amber { font-weight: 600; }

.lms-select {
  appearance: none;
  -webkit-appearance: none;
  padding-right: 34px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 14px center;
  cursor: pointer;
}
.lms-select option { background: #16181b; color: #fff; }

.lms-btn:disabled { opacity: 0.4; cursor: default; }
.lms-pager { display: inline-flex; align-items: center; gap: 10px; }

/* Sidebar logo: small and left aligned like the design */
.sidenav.lms-sidenav .sidenav-header {
  height: auto;
  padding: 24px 26px 20px;
}
.sidenav.lms-sidenav .navbar-brand {
  padding: 0;
  text-align: left;
}
.navbar-vertical.lms-sidenav .navbar-brand-img {
  height: 22px;
  max-height: 22px;
  width: auto;
}
.lms-main label.lms-label { font-size: 11px; }
.lms-main label.lms-check { font-size: 13px; }
.lms-table td .lms-btn-sm { padding: 5px 10px; }
@media (max-width: 1400px) {
  .lms-table th,
  .lms-table td { padding-left: 12px; padding-right: 12px; }
}

/* Create class: field errors, student search results, selected students */
.lms-field-error { color: #ff5a5a; font-size: 12px; margin-top: 6px; }
.lms-link:disabled { opacity: 0.5; cursor: default; }
.lms-results { margin-top: 6px; border: 1px solid #2f3439; border-radius: 8px; max-height: 220px; overflow-y: auto; }
.lms-result {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 9px 12px;
  background: none;
  border: 0;
  border-bottom: 1px solid #2a2e33;
  color: #e9eaec;
  font-size: 13px;
  text-align: left;
  cursor: pointer;
}
.lms-result:last-child { border-bottom: 0; }
.lms-result:hover:not(:disabled) { background: #1b1e21; }
.lms-result:disabled { cursor: default; opacity: 0.6; }
.lms-student-chips { max-height: 160px; overflow-y: auto; margin: 10px 0 0; }
.lms-conflict + .lms-conflict { margin-top: 8px; }

/* Class detail: label / value rows in the side card */
.lms-detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 9px 0;
  border-bottom: 1px solid #2a2e33;
  font-size: 13px;
  color: #e9eaec;
}
.lms-detail-row:last-child { border-bottom: 0; }
.lms-detail-row > span:first-child { color: #9aa0a6; }
.lms-detail-row > span:last-child { text-align: right; }

/* Confirm dialog (lmsConfirm): dark card on a dim overlay, replaces the white react-confirm-alert box */
.react-confirm-alert-overlay.lms-confirm-overlay {
  background: rgba(5, 6, 8, 0.72);
  z-index: 2000;
  padding: 16px;
  animation: lms-fade-in 0.15s forwards;
}
.lms-confirm {
  width: min(440px, calc(100vw - 32px));
  background: #16181b;
  border: 1px solid #2a2e33;
  border-radius: 14px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.55);
  padding: 22px 22px 20px;
  color: #e9eaec;
  font-family: "Inter", -apple-system, "Segoe UI", sans-serif;
  -webkit-font-smoothing: antialiased;
  animation: lms-pop-in 0.18s ease-out;
}
.lms-confirm-title { font-size: 17px; font-weight: 600; color: #fff; margin: 0 0 14px; }
.lms-confirm-summary {
  background: #0f1113;
  border: 1px solid #2a2e33;
  border-radius: 10px;
  padding: 12px 14px;
  font-size: 14px;
  margin-bottom: 12px;
}
.lms-confirm-text { font-size: 13px; line-height: 1.55; color: #9aa0a6; margin: 0 0 20px; }
.lms-confirm-actions { display: flex; justify-content: flex-end; gap: 10px; flex-wrap: wrap; }
.lms-btn-danger-fill { background: #e5484d; border-color: #e5484d; color: #fff; }
.lms-btn-danger-fill:hover { background: #f05a5f; border-color: #f05a5f; color: #fff; }
@keyframes lms-fade-in { from { opacity: 0; } to { opacity: 1; } }
@keyframes lms-pop-in { from { opacity: 0; transform: translateY(6px) scale(0.98); } to { opacity: 1; transform: none; } }

/* space between two cards stacked in one column */
.lms-section-gap { height: 18px; }
.lms-confirm-input { display: block; box-sizing: border-box; resize: vertical; min-height: 76px; margin: 0 0 18px; font-family: inherit; font-size: 13px; }

/* Cancel a class dialog (confirmCancel in LmsClasses) */
.lms-confirm.lms-cancel {
  width: min(720px, calc(100vw - 32px));
  max-height: calc(100vh - 32px);
  overflow-y: auto;
  padding: 28px 32px 24px;
}
.lms-cancel-head { display: flex; justify-content: space-between; align-items: flex-start; gap: 16px; margin-bottom: 24px; }
.lms-cancel-title { font-size: 24px; font-weight: 700; color: #fff; margin: 0 0 4px; letter-spacing: -0.01em; }
.lms-cancel-sub { font-size: 14px; color: #9aa0a6; margin: 0; }
.lms-cancel-close {
  background: none;
  border: 0;
  color: #9aa0a6;
  font-size: 22px;
  line-height: 1;
  padding: 2px 4px;
  cursor: pointer;
}
.lms-cancel-close:hover { color: #fff; }
.lms-cancel .lms-form-row { margin-bottom: 22px; }
.lms-cancel-value {
  background: #0f1113;
  border: 1px solid #2a2e33;
  border-radius: 10px;
  padding: 14px 16px;
  font-size: 15px;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.lms-cancel-section { margin-bottom: 22px; }
.lms-cancel-reason { border-radius: 999px; padding: 9px 16px; }
.lms-cancel-reason.active,
.lms-cancel-reason.active:hover { background: #ff4a17; border-color: #ff4a17; color: #fff; }
.lms-cancel-message {
  display: block;
  resize: vertical;
  min-height: 130px;
  border-radius: 10px;
  padding: 14px 16px;
  font-family: inherit;
  font-size: 15px;
}
.lms-cancel-checks .lms-check { font-size: 15px; margin-bottom: 16px; }
.lms-cancel-checks .lms-check input {
  appearance: none;
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  background: #0f1113 center / 14px no-repeat;
  border: 1px solid #3a3f45;
  border-radius: 5px;
  cursor: inherit;
}
.lms-cancel-checks .lms-check input:checked {
  background-color: #ff4a17;
  border-color: #ff4a17;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.lms-cancel-checks .lms-check input:focus-visible { outline: 2px solid #ff4a17; outline-offset: 2px; }
.lms-check-fixed { cursor: default; }
.lms-check-fixed input { pointer-events: none; }
.lms-check-tag {
  margin-left: auto;
  font-family: "JetBrains Mono", "SFMono-Regular", Consolas, monospace;
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #6b7178;
}
.lms-cancel-foot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  border-top: 1px solid #2a2e33;
  margin-top: 20px;
  padding-top: 20px;
}
.lms-cancel-note { font-size: 13px; color: #9aa0a6; }
.lms-cancel-foot .lms-btn { padding: 11px 20px; font-size: 15px; border-radius: 10px; }
.lms-cancel-foot .lms-btn:disabled { opacity: 0.4; cursor: default; }

/* Sub admins (LmsSubAdmins) */
.lms-subadmin-search { display: block; width: 100%; box-sizing: border-box; }
.lms-subadmin-results { display: flex; flex-direction: column; gap: 6px; margin-top: 10px; max-height: 240px; overflow-y: auto; }
.lms-subadmin-result {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  background: #0f1113;
  border: 1px solid #2a2e33;
  border-radius: 8px;
  padding: 10px 12px;
  color: #e9eaec;
  cursor: pointer;
}
.lms-subadmin-result:hover { border-color: #ff4a17; }
.lms-subadmin-sections { display: flex; gap: 6px; flex-wrap: wrap; }
.lms-subadmin-sections .lms-chip { padding: 4px 10px; font-weight: 500; }
/* section from a role (Roles screen), not editable here */
.lms-subadmin-sections .lms-chip-role { background: transparent; border-style: dashed; color: #9aa0a6; }
@media (max-width: 576px) {
  .lms-confirm.lms-cancel { padding: 22px 18px 18px; }
  .lms-cancel .lms-form-row { grid-template-columns: 1fr; }
  .lms-cancel-foot .lms-confirm-actions { width: 100%; }
  .lms-cancel-foot .lms-btn { flex: 1 1; }
}

/* Dashboard charts */
.lms-charts {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 2fr);
  gap: 14px;
  margin-bottom: 18px;
}
.lms-chart-card { padding: 18px; overflow: visible; }
.lms-chart-frame { position: relative; margin-top: 8px; }
.lms-chart-overlay {
  position: absolute;
  inset: 0 0 24px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0 16px;
  color: #9aa0a6;
  font-size: 13px;
  pointer-events: none;
}
.lms-chart-note { margin-top: 12px; text-align: center; font-size: 12px; color: #9aa0a6; }
.lms-chart-empty {
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9aa0a6;
  font-size: 13px;
}
.lms-donut { position: relative; margin-top: 8px; }
.lms-donut-center {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}
.lms-donut-value { font-size: 26px; font-weight: 700; color: #fff; line-height: 1.1; }
.lms-chart-legend {
  list-style: none;
  padding: 0;
  margin: 12px 0 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 6px 18px;
  font-size: 12px;
  color: #b3b8bd;
}
.lms-chart-legend li { display: flex; align-items: center; gap: 6px; }
.lms-chart-legend strong { color: #fff; }
.lms-chart-swatch { width: 10px; height: 10px; border-radius: 2px; display: inline-block; flex-shrink: 0; }
.lms-chart-tooltip {
  background: #0f1113;
  border: 1px solid #2a2e33;
  border-radius: 8px;
  padding: 8px 10px;
  font-size: 12px;
  color: #b3b8bd;
}
.lms-chart-tooltip-title { color: #fff; font-weight: 600; margin-bottom: 4px; }
.lms-chart-tooltip-row { display: flex; align-items: center; gap: 6px; }
.lms-chart-tooltip-row strong { color: #fff; margin-left: auto; padding-left: 12px; }

@media (max-width: 991px) {
  .lms-charts { grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); }
  .lms-charts > :last-child { grid-column: 1 / -1; }
}
@media (max-width: 575px) {
  .lms-charts { grid-template-columns: minmax(0, 1fr); }
}

.lms-week-card { margin-bottom: 18px; }
.lms-chart-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  flex-wrap: wrap;
}
.lms-week-nav { display: flex; gap: 6px; }

/* Check-in location dialog (LmsLocation) */
.lms-confirm.lms-location { width: min(640px, calc(100vw - 32px)); }
.lms-location-sub { margin-bottom: 12px; }
.lms-location-map { display: block; width: 100%; height: 340px; border: 1px solid #2a2e33; border-radius: 10px; background: #0f1113; }
.lms-location-meta { display: flex; justify-content: space-between; gap: 10px; flex-wrap: wrap; font-size: 12px; color: #9aa0a6; margin: 10px 0 18px; }
.lms-location-link { display: block; margin-top: 2px; }
.lms-location-name { font-size: 13px; color: #e8eaed; line-height: 1.4; margin: 0 0 12px; }
.lms-location-place { max-width: 240px; margin-top: 2px; white-space: normal; line-height: 1.35; }

/* react-datepicker (Create / Edit class date) in the dark theme */
.lms-main .react-datepicker-wrapper { display: block; width: 100%; }
.lms-datepicker.react-datepicker {
  background: #16181b;
  border: 1px solid #2f3439;
  border-radius: 10px;
  color: #e9eaec;
  font-family: inherit;
  font-size: 13px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
}
.lms-datepicker .react-datepicker__header {
  background: #1d2024;
  border-bottom: 1px solid #2f3439;
  border-top-left-radius: 10px;
}
.lms-datepicker .react-datepicker__current-month,
.lms-datepicker .react-datepicker__day-name { color: #e9eaec; }
.lms-datepicker .react-datepicker__day { color: #e9eaec; border-radius: 6px; }
.lms-datepicker .react-datepicker__day:hover { background: #2a2e33; }
.lms-datepicker .react-datepicker__day--outside-month { color: #555b62; }
.lms-datepicker .react-datepicker__day--today { font-weight: 700; color: #ff4a17; }
.lms-datepicker .react-datepicker__day--selected,
.lms-datepicker .react-datepicker__day--keyboard-selected { background: #ff4a17; color: #fff; }
.lms-datepicker .react-datepicker__navigation-icon::before { border-color: #9aa0a6; }
.lms-datepicker .react-datepicker__today-button {
  background: #1d2024;
  border-top: 1px solid #2f3439;
  color: #e9eaec;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.react-datepicker-popper:has(.lms-datepicker) .react-datepicker__triangle { display: none; }
.react-datepicker-popper:has(.lms-datepicker) { z-index: 20; }
`, "",{"version":3,"sources":["webpack://./src/components/Lms/lms.css"],"names":[],"mappings":"AAAA,oEAAoE;;AAGpE;;;EAGE,2DAA2D;EAC3D,mCAAmC;AACrC;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;AACA;;;;EAIE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,2CAA2C;AAC7C;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oEAAoE;EACpE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;AACvB;AACA,iBAAiB,qBAAqB,EAAE,WAAW,EAAE,qBAAqB,EAAE;AAC5E,mBAAmB,mBAAmB,EAAE,qBAAqB,EAAE;AAC/D,yBAAyB,mBAAmB,EAAE,qBAAqB,EAAE;AACrE,cAAc,iBAAiB,EAAE,eAAe,EAAE,kBAAkB,EAAE;AACtE,kBAAkB,cAAc,EAAE,qBAAqB,EAAE;AACzD,wBAAwB,cAAc,EAAE,qBAAqB,EAAE;;AAE/D,eAAe;AACf;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,cAAc,yBAAyB,EAAE;AACzC,YAAY,yBAAyB,EAAE;AACvC,cAAc,yBAAyB,EAAE;AACzC;0BAC0B,cAAc,EAAE;;AAE1C,iBAAiB;AACjB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,gCAAgC;AAClC;AACA,YAAY,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE;AACtD;EACE,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;AACA,iBAAiB,WAAW,EAAE;AAC9B,kBAAkB,mBAAmB,EAAE,WAAW,EAAE;;AAEpD;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;AACA;oBACoB,qBAAqB,EAAE;AAC3C,0BAA0B,cAAc,EAAE;AAC1C,cAAc,gBAAgB,EAAE,eAAe,EAAE;;AAEjD,kBAAkB,gBAAgB,EAAE;AACpC;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,oEAAoE;EACpE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;AACA,8BAA8B,gBAAgB,EAAE;AAChD,gCAAgC,eAAe,EAAE;AACjD,yCAAyC,mBAAmB,EAAE;AAC9D,gCAAgC,cAAc,EAAE;AAChD,cAAc,gBAAgB,EAAE,WAAW,EAAE;AAC7C,WAAW,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AAC7D,cAAc,6BAA6B,EAAE,cAAc,EAAE;AAC7D,aAAa,kBAAkB,EAAE,cAAc,EAAE,wBAAwB,EAAE;AAC3E,mBAAmB,aAAa,EAAE,QAAQ,EAAE;;AAE5C;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;AACA,eAAe,mBAAmB,EAAE,cAAc,EAAE;AACpD,eAAe,mBAAmB,EAAE,cAAc,EAAE;AACpD,aAAa,mBAAmB,EAAE,cAAc,EAAE;AAClD,cAAc,mBAAmB,EAAE,cAAc,EAAE;AACnD,cAAc,mBAAmB,EAAE,cAAc,EAAE;;AAEnD,4BAA4B;AAC5B,cAAc,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAC7D;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,6EAA6E;AAC/E;AACA,WAAW,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAC1D,iBAAiB,WAAW,EAAE,WAAW,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AACtG,gBAAgB,YAAY,EAAE,kBAAkB,EAAE;;AAElD,sBAAsB;AACtB;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;AACA,iBAAiB,aAAa,EAAE;AAChC;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;AACA,kBAAkB,aAAa,EAAE,8BAA8B,EAAE,SAAS,EAAE;AAC5E,wBAAwB,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC3F,eAAe,6BAA6B,EAAE,cAAc,EAAE;AAC9D,WAAW,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE;AACrD,2BAA2B,mBAAmB,EAAE,qBAAqB,EAAE;AACvE,gBAAgB,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE,mBAAmB,EAAE;AAC/E;EACE,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA,mBAAmB,gBAAgB,EAAE,SAAS,EAAE,cAAc,EAAE,UAAU,EAAE,eAAe,EAAE;AAC7F,gBAAgB,uBAAuB,EAAE,cAAc,EAAE,eAAe,EAAE;AAC1E,YAAY,gBAAgB,EAAE,SAAS,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE,UAAU,EAAE;AACzH,kBAAkB,aAAa,EAAE,8BAA8B,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AAC1G;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;AACA,iBAAiB,aAAa,EAAE,mBAAmB,EAAE;AACrD,4BAA4B,mBAAmB,EAAE,cAAc,EAAE;AACjE;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,aAAa;EACb,SAAS;AACX;AACA,WAAW,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,eAAe,EAAE,cAAc,EAAE;AACzF,UAAU,eAAe,EAAE,cAAc,EAAE,aAAa,EAAE,QAAQ,EAAE,gBAAgB,EAAE;AACtF,aAAa,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAClJ,mBAAmB,WAAW,EAAE,YAAY,EAAE,SAAS,EAAE,qBAAqB,EAAE;;AAEhF,cAAc;AACd,gBAAgB,iBAAiB,EAAE,gBAAgB,EAAE;AACrD,+BAA+B,2CAA2C,EAAE;AAC5E,+BAA+B,mBAAmB,EAAE;AACpD,+BAA+B,iBAAiB,EAAE;AAClD,sCAAsC,mBAAmB,EAAE,qBAAqB,EAAE,WAAW,EAAE;AAC/F,4BAA4B,iBAAiB,EAAE,oBAAoB,EAAE;AACrE,yBAAyB,iBAAiB,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;AACrF,+CAA+C,eAAe,EAAE,mBAAmB,EAAE;AACrF,qCAAqC,cAAc,EAAE;AACrD,wCAAwC,aAAa,EAAE,mBAAmB,EAAE;AAC5E;EACE,aAAa;EACb,8BAA8B;EAC9B,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;AACA,kBAAkB,aAAa,EAAE,8BAA8B,EAAE,SAAS,EAAE,eAAe,EAAE,mBAAmB,EAAE;AAClH,6BAA6B,gBAAgB,EAAE;AAC/C,oBAAoB,cAAc,EAAE,YAAY,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAClH,6BAA6B,mBAAmB,EAAE;AAClD,mCAAmC,mBAAmB,EAAE,mBAAmB,EAAE;AAC7E,oBAAoB,qBAAqB,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AACnH;EACE,+BAA+B,0BAA0B,EAAE;AAC7D;;AAEA,8BAA8B;AAC9B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;AACA,yBAAyB,WAAW,EAAE,qBAAqB,EAAE;AAC7D,0BAA0B,mBAAmB,EAAE,WAAW,EAAE;;AAE5D,wEAAwE;AACxE;EACE,yBAAyB;EACzB,+BAA+B;AACjC;AACA;EACE,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,oEAAoE;EACpE,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,2EAA2E;AAC3E;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB,0BAA0B,EAAE;AAC/C;AACA;EACE,aAAa,gDAAgD,EAAE;AACjE;AACA;EACE,YAAY,uBAAuB,EAAE;EACrC,aAAa,0BAA0B,EAAE;EACzC,gBAAgB,0BAA0B,EAAE;EAC5C,cAAc,eAAe,EAAE;AACjC;;AAEA,iDAAiD;AACjD;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;4BAC4B,kBAAkB,EAAE;AAChD;2BAC2B,mBAAmB,EAAE;AAChD;;8BAE8B,gBAAgB,EAAE;;AAEhD;EACE,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,yDAAqL;EACrL,4BAA4B;EAC5B,sCAAsC;EACtC,eAAe;AACjB;AACA,qBAAqB,mBAAmB,EAAE,WAAW,EAAE;;AAEvD,oBAAoB,YAAY,EAAE,eAAe,EAAE;AACnD,aAAa,oBAAoB,EAAE,mBAAmB,EAAE,SAAS,EAAE;;AAEnE,yDAAyD;AACzD;EACE,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;AACA,4BAA4B,eAAe,EAAE;AAC7C,4BAA4B,eAAe,EAAE;AAC7C,4BAA4B,iBAAiB,EAAE;AAC/C;EACE;kBACgB,kBAAkB,EAAE,mBAAmB,EAAE;AAC3D;;AAEA,0EAA0E;AAC1E,mBAAmB,cAAc,EAAE,eAAe,EAAE,eAAe,EAAE;AACrE,qBAAqB,YAAY,EAAE,eAAe,EAAE;AACpD,eAAe,eAAe,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AACpH;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA,yBAAyB,gBAAgB,EAAE;AAC3C,mCAAmC,mBAAmB,EAAE;AACxD,uBAAuB,eAAe,EAAE,YAAY,EAAE;AACtD,qBAAqB,iBAAiB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AAC5E,gCAAgC,eAAe,EAAE;;AAEjD,sDAAsD;AACtD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,cAAc;AAChB;AACA,6BAA6B,gBAAgB,EAAE;AAC/C,qCAAqC,cAAc,EAAE;AACrD,oCAAoC,iBAAiB,EAAE;;AAEvD,wGAAwG;AACxG;EACE,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,qCAAqC;AACvC;AACA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;EAC3C,uBAAuB;EACvB,cAAc;EACd,2DAA2D;EAC3D,mCAAmC;EACnC,oCAAoC;AACtC;AACA,qBAAqB,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE,gBAAgB,EAAE;AACvF;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;AACA,oBAAoB,eAAe,EAAE,iBAAiB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AAC1F,uBAAuB,aAAa,EAAE,yBAAyB,EAAE,SAAS,EAAE,eAAe,EAAE;AAC7F,uBAAuB,mBAAmB,EAAE,qBAAqB,EAAE,WAAW,EAAE;AAChF,6BAA6B,mBAAmB,EAAE,qBAAqB,EAAE,WAAW,EAAE;AACtF,yBAAyB,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;AACjE,wBAAwB,OAAO,UAAU,EAAE,sCAAsC,EAAE,EAAE,KAAK,UAAU,EAAE,eAAe,EAAE,EAAE;;AAEzH,kDAAkD;AAClD,mBAAmB,YAAY,EAAE;AACjC,qBAAqB,cAAc,EAAE,sBAAsB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,oBAAoB,EAAE,eAAe,EAAE;;AAE1J,wDAAwD;AACxD;EACE,qCAAqC;EACrC,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;AACzB;AACA,mBAAmB,aAAa,EAAE,8BAA8B,EAAE,uBAAuB,EAAE,SAAS,EAAE,mBAAmB,EAAE;AAC3H,oBAAoB,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE,eAAe,EAAE,uBAAuB,EAAE;AAC9G,kBAAkB,eAAe,EAAE,cAAc,EAAE,SAAS,EAAE;AAC9D;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA,0BAA0B,WAAW,EAAE;AACvC,4BAA4B,mBAAmB,EAAE;AACjD;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA,sBAAsB,mBAAmB,EAAE;AAC3C,qBAAqB,oBAAoB,EAAE,iBAAiB,EAAE;AAC9D;kCACkC,mBAAmB,EAAE,qBAAqB,EAAE,WAAW,EAAE;AAC3F;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;AACjB;AACA,gCAAgC,eAAe,EAAE,mBAAmB,EAAE;AACtE;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,2CAA2C;EAC3C,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,yDAAuP;AACzP;AACA,oDAAoD,0BAA0B,EAAE,mBAAmB,EAAE;AACrG,mBAAmB,eAAe,EAAE;AACpC,yBAAyB,oBAAoB,EAAE;AAC/C;EACE,iBAAiB;EACjB,oEAAoE;EACpE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;AACnB;AACA,mBAAmB,eAAe,EAAE,cAAc,EAAE;AACpD,4BAA4B,kBAAkB,EAAE,eAAe,EAAE,mBAAmB,EAAE;AACtF,qCAAqC,YAAY,EAAE,eAAe,EAAE;;AAEpE,8BAA8B;AAC9B,uBAAuB,cAAc,EAAE,WAAW,EAAE,sBAAsB,EAAE;AAC5E,wBAAwB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AAChI;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA,6BAA6B,qBAAqB,EAAE;AACpD,yBAAyB,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE;AACnE,mCAAmC,iBAAiB,EAAE,gBAAgB,EAAE;AACxE,0DAA0D;AAC1D,wCAAwC,uBAAuB,EAAE,oBAAoB,EAAE,cAAc,EAAE;AACvG;EACE,0BAA0B,uBAAuB,EAAE;EACnD,4BAA4B,0BAA0B,EAAE;EACxD,wCAAwC,WAAW,EAAE;EACrD,4BAA4B,SAAO,EAAE;AACvC;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mEAAmE;EACnE,SAAS;EACT,mBAAmB;AACrB;AACA,kBAAkB,aAAa,EAAE,iBAAiB,EAAE;AACpD,mBAAmB,kBAAkB,EAAE,eAAe,EAAE;AACxD;EACE,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;AACA,kBAAkB,gBAAgB,EAAE,kBAAkB,EAAE,eAAe,EAAE,cAAc,EAAE;AACzF;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;AACA,aAAa,kBAAkB,EAAE,eAAe,EAAE;AAClD;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;AACA,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE,gBAAgB,EAAE;AACrF;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,cAAc;AAChB;AACA,uBAAuB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACrE,2BAA2B,WAAW,EAAE;AACxC,oBAAoB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAC1G;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;AACA,2BAA2B,WAAW,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AAC9E,yBAAyB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACvE,gCAAgC,WAAW,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;;AAEpF;EACE,cAAc,oDAAoD,EAAE;EACpE,4BAA4B,mBAAmB,EAAE;AACnD;AACA;EACE,cAAc,qCAAqC,EAAE;AACvD;;AAEA,iBAAiB,mBAAmB,EAAE;AACtC;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;AACA,gBAAgB,aAAa,EAAE,QAAQ,EAAE;;AAEzC,2CAA2C;AAC3C,4BAA4B,qCAAqC,EAAE;AACnE,oBAAoB,mBAAmB,EAAE;AACzC,oBAAoB,cAAc,EAAE,WAAW,EAAE,aAAa,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE;AACrI,qBAAqB,aAAa,EAAE,8BAA8B,EAAE,SAAS,EAAE,eAAe,EAAE,eAAe,EAAE,cAAc,EAAE,mBAAmB,EAAE;AACtJ,qBAAqB,cAAc,EAAE,eAAe,EAAE;AACtD,qBAAqB,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AAC1F,sBAAsB,gBAAgB,EAAE,eAAe,EAAE,mBAAmB,EAAE,iBAAiB,EAAE;;AAEjG,kEAAkE;AAClE,sCAAsC,cAAc,EAAE,WAAW,EAAE;AACnE;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,0CAA0C;AAC5C;AACA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,4BAA4B;AAC9B;AACA;8CAC8C,cAAc,EAAE;AAC9D,yCAAyC,cAAc,EAAE,kBAAkB,EAAE;AAC7E,+CAA+C,mBAAmB,EAAE;AACpE,wDAAwD,cAAc,EAAE;AACxE,gDAAgD,gBAAgB,EAAE,cAAc,EAAE;AAClF;4DAC4D,mBAAmB,EAAE,WAAW,EAAE;AAC9F,6DAA6D,qBAAqB,EAAE;AACpF;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,cAAc;EACd,+BAA+B;EAC/B,gCAAgC;AAClC;AACA,4EAA4E,aAAa,EAAE;AAC3F,gDAAgD,WAAW,EAAE","sourcesContent":["/* LMS (training) screens — dark theme matching the pluc.tv design */\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap\");\n\n.lms-main,\n.lms-sidenav,\n.lms-topbar {\n  font-family: \"Inter\", -apple-system, \"Segoe UI\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n}\n.lms-main {\n  background: #0b0c0e;\n  min-height: 100vh;\n  color: #e9eaec;\n}\n.lms-main input,\n.lms-main select,\n.lms-main textarea,\n.lms-main button {\n  font-family: inherit;\n  color-scheme: dark;\n}\n\n/* Header while on LMS pages */\n.topbar.lms-topbar {\n  background: #000;\n  border-bottom: 1px solid #1c1f23 !important;\n}\n.lms-topbar .hdr-greet,\n.lms-topbar .hdr-logout {\n  font-size: 13px !important;\n}\n.lms-topbar .hdr-greet {\n  font-weight: 600;\n  margin-right: 1.5rem !important;\n}\n.lms-topbar .hdr-logout {\n  color: #b8bcc1 !important;\n  cursor: pointer;\n}\n.lms-topbar .hdr-logout:hover {\n  color: #fff !important;\n}\n\n.lms-page {\n  padding: 28px 28px 40px;\n}\n\n.lms-page-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-bottom: 20px;\n}\n\n.lms-title {\n  font-size: 24px;\n  font-weight: 700;\n  color: #fff;\n  margin: 0;\n}\n\n.lms-subtitle {\n  font-size: 13px;\n  color: #9aa0a6;\n  margin: 4px 0 0;\n}\n\n.lms-actions {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.lms-label {\n  font-family: \"JetBrains Mono\", \"SFMono-Regular\", Consolas, monospace;\n  font-size: 11px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #9aa0a6;\n}\n\n/* Buttons */\n.lms-btn {\n  border-radius: 8px;\n  padding: 9px 16px;\n  font-size: 13px;\n  font-weight: 600;\n  border: 1px solid #3a3f45;\n  background: transparent;\n  color: #fff;\n  cursor: pointer;\n  white-space: nowrap;\n  text-decoration: none;\n  display: inline-block;\n}\n.lms-btn:hover { border-color: #6b7178; color: #fff; text-decoration: none; }\n.lms-btn-primary { background: #ff4a17; border-color: #ff4a17; }\n.lms-btn-primary:hover { background: #ff5f33; border-color: #ff5f33; }\n.lms-btn-sm { padding: 5px 12px; font-size: 12px; border-radius: 6px; }\n.lms-btn-danger { color: #ff5a5a; border-color: #7a2a2a; }\n.lms-btn-danger:hover { color: #ff7a7a; border-color: #a33a3a; }\n\n/* Stat cards */\n.lms-stats {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 14px;\n  margin-bottom: 18px;\n}\n.lms-stat {\n  background: #16181b;\n  border: 1px solid #2a2e33;\n  border-radius: 12px;\n  padding: 18px 18px 16px;\n}\n.lms-stat-value {\n  font-size: 26px;\n  font-weight: 700;\n  color: #fff;\n  margin-top: 6px;\n  line-height: 1.2;\n}\n.lms-stat-sub {\n  font-size: 12px;\n  color: #9aa0a6;\n  margin-top: 4px;\n}\n\n.tone-green { color: #34c26b !important; }\n.tone-red { color: #ff5a5a !important; }\n.tone-amber { color: #f5a524 !important; }\n.lms-muted,\n.lms-table td.lms-muted { color: #9aa0a6; }\n\n/* Card + table */\n.lms-card {\n  background: #16181b;\n  border: 1px solid #2a2e33;\n  border-radius: 12px;\n  overflow: hidden;\n}\n.lms-toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 16px 20px;\n  border-bottom: 1px solid #2a2e33;\n}\n.lms-tabs { display: flex; gap: 4px; flex-wrap: wrap; }\n.lms-tab {\n  background: transparent;\n  border: 0;\n  color: #b3b8bd;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 7px 12px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n.lms-tab:hover { color: #fff; }\n.lms-tab.active { background: #2a2e33; color: #fff; }\n\n.lms-input,\n.lms-select {\n  background: #0f1113;\n  border: 1px solid #2f3439;\n  border-radius: 8px;\n  color: #fff;\n  font-size: 14px;\n  padding: 10px 12px;\n  width: 100%;\n  outline: none;\n}\n.lms-input:focus,\n.lms-select:focus { border-color: #ff4a17; }\n.lms-input::placeholder { color: #6b7178; }\n.lms-search { max-width: 270px; font-size: 13px; }\n\n.lms-table-wrap { overflow-x: auto; }\n.lms-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n.lms-table th {\n  font-family: \"JetBrains Mono\", \"SFMono-Regular\", Consolas, monospace;\n  font-size: 11px;\n  font-weight: 500;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #9aa0a6;\n  padding: 12px 16px;\n  border-bottom: 1px solid #2a2e33;\n  white-space: nowrap;\n}\n.lms-table td {\n  padding: 12px 16px;\n  border-bottom: 1px solid #22262a;\n  color: #e9eaec;\n  vertical-align: middle;\n  white-space: nowrap;\n}\n.lms-table tr:last-child td { border-bottom: 0; }\n.lms-table tbody tr.clickable { cursor: pointer; }\n.lms-table tbody tr.clickable:hover td { background: #1b1e21; }\n.lms-table tr.is-cancelled td { color: #7d8288; }\n.lms-strong { font-weight: 600; color: #fff; }\n.lms-sub { font-size: 11px; color: #8d9399; margin-top: 2px; }\n.lms-strike { text-decoration: line-through; color: #7d8288; }\n.lms-empty { text-align: center; color: #8d9399; padding: 30px !important; }\n.lms-row-actions { display: flex; gap: 8px; }\n\n.lms-card-foot {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 14px 20px;\n  border-top: 1px solid #2a2e33;\n  font-size: 12px;\n  color: #9aa0a6;\n}\n\n/* Badges */\n.lms-badge {\n  display: inline-block;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 3px 9px;\n  border-radius: 999px;\n}\n.badge-amber { background: #3a2c12; color: #f5a524; }\n.badge-green { background: #133222; color: #34c26b; }\n.badge-red { background: #3a1719; color: #ff5a5a; }\n.badge-grey { background: #2a2e33; color: #d3d6d9; }\n.badge-blue { background: #132a40; color: #4ea1ff; }\n\n/* Student / trainer cells */\n.lms-person { display: flex; align-items: center; gap: 12px; }\n.lms-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 6px;\n  flex-shrink: 0;\n  border: 1px solid #3a3f45;\n  background: repeating-linear-gradient(135deg, #22262a 0 4px, #2e3338 4px 8px);\n}\n.lms-bar { display: flex; align-items: center; gap: 10px; }\n.lms-bar-track { width: 74px; height: 5px; border-radius: 3px; background: #2a2e33; overflow: hidden; }\n.lms-bar-fill { height: 100%; border-radius: 3px; }\n\n/* Create class form */\n.lms-form-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 310px;\n  gap: 18px;\n  align-items: start;\n}\n.lms-form-card { padding: 22px; }\n.lms-form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n.lms-form-row-3 { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }\n.lms-field .lms-label { display: block; margin: 0 0 8px; font-weight: 500; color: #9aa0a6; }\n.lms-divider { border-top: 1px solid #2a2e33; margin: 20px 0; }\n.lms-seg { display: flex; gap: 8px; flex-wrap: wrap; }\n.lms-seg .lms-btn.active { background: #ff4a17; border-color: #ff4a17; }\n.lms-chip-row { display: flex; gap: 8px; flex-wrap: wrap; margin-bottom: 18px; }\n.lms-chip {\n  background: #2a2e33;\n  border: 1px solid #3a3f45;\n  border-radius: 999px;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 600;\n  padding: 6px 12px;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n.lms-chip button { background: none; border: 0; color: #9aa0a6; padding: 0; cursor: pointer; }\n.lms-chip-add { background: transparent; color: #d3d6d9; cursor: pointer; }\n.lms-link { background: none; border: 0; color: #ff5a2e; font-size: 12px; font-weight: 600; cursor: pointer; padding: 0; }\n.lms-field-head { display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; }\n.lms-selected-box {\n  margin-top: 10px;\n  border: 1px solid #2f3439;\n  border-radius: 8px;\n  padding: 12px 14px;\n  display: flex;\n  justify-content: space-between;\n  font-size: 13px;\n  font-weight: 600;\n}\n.lms-side-card { padding: 18px; margin-bottom: 14px; }\n.lms-side-card .lms-label { margin-bottom: 12px; display: block; }\n.lms-conflict {\n  background: #2a2412;\n  border: 1px solid #5a4a1c;\n  border-radius: 8px;\n  padding: 12px;\n  font-size: 13px;\n  display: flex;\n  gap: 10px;\n}\n.lms-dot { width: 7px; height: 7px; border-radius: 50%; margin-top: 6px; flex-shrink: 0; }\n.lms-ok { font-size: 12px; color: #9aa0a6; display: flex; gap: 8px; margin-top: 12px; }\n.lms-check { display: flex; align-items: center; gap: 10px; font-size: 13px; font-weight: 400; color: #e9eaec; margin: 0 0 12px; cursor: pointer; }\n.lms-check input { width: 18px; height: 18px; margin: 0; accent-color: #ff4a17; }\n\n/* Broadcast */\n.lms-textarea { min-height: 120px; resize: vertical; }\n.lms-form-grid.lms-broadcast { grid-template-columns: minmax(0, 1fr) 330px; }\n.lms-broadcast .lms-chip-row { margin-bottom: 18px; }\n.lms-broadcast .lms-chip-add { padding: 9px 14px; }\n.lms-broadcast .lms-chip-add.active { background: #ff4a17; border-color: #ff4a17; color: #fff; }\n.lms-broadcast .lms-input { padding-top: 11px; padding-bottom: 11px; }\n.lms-broadcast-message { min-height: 160px; line-height: 1.7; white-space: pre-wrap; }\n.lms-broadcast .lms-cancel-checks .lms-check { font-size: 13px; margin-bottom: 14px; }\n.lms-broadcast .lms-check-off span { color: #9aa0a6; }\n.lms-broadcast .lms-check.is-disabled { opacity: 0.45; cursor: not-allowed; }\n.lms-sending-to {\n  display: flex;\n  justify-content: space-between;\n  border-top: 1px solid #2a2e33;\n  padding-top: 16px;\n  margin-top: 4px;\n  font-size: 13px;\n  color: #9aa0a6;\n}\n.lms-recent-row { display: flex; justify-content: space-between; gap: 12px; font-size: 12px; margin-bottom: 10px; }\n.lms-recent-row:last-child { margin-bottom: 0; }\n.lms-recent-title { color: #e9eaec; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.lms-recent-row .lms-muted { white-space: nowrap; }\n.lms-table tr.lms-sent-detail td { white-space: normal; background: #0f1113; }\n.lms-sent-message { white-space: pre-line; font-size: 13px; line-height: 1.6; color: #c9ccd0; margin-bottom: 10px; }\n@media (max-width: 1200px) {\n  .lms-form-grid.lms-broadcast { grid-template-columns: 1fr; }\n}\n\n/* Header Admin / LMS switch */\n.header-switch {\n  display: inline-flex;\n  background: #16181b;\n  border: 1px solid #2a2e33;\n  border-radius: 8px;\n  padding: 3px;\n  margin-right: 24px;\n}\n.header-switch a {\n  color: #b3b8bd;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 5px 14px;\n  border-radius: 6px;\n  text-decoration: none;\n}\n.header-switch a:hover { color: #fff; text-decoration: none; }\n.header-switch a.active { background: #ff4a17; color: #fff; }\n\n/* LMS sidebar — overrides the admin sidebar styles from dashboard.css */\n.navbar-vertical.navbar-expand-xs.lms-sidenav {\n  background-color: #111316;\n  border-right: 1px solid #22262a;\n}\n.lms-sidenav .sidenav-header {\n  height: auto;\n  padding: 26px 26px 22px;\n}\n.lms-sidenav .navbar-brand {\n  padding: 0;\n}\n.lms-sidenav .navbar-brand-img {\n  max-height: 22px;\n  width: auto;\n}\n.lms-sidenav .navbar-collapse {\n  display: block;\n}\n.lms-sidenav .navbar-nav {\n  width: 100%;\n  padding: 0;\n}\n.lms-sidenav.navbar-vertical .navbar-nav > .nav-item {\n  margin-bottom: 2px;\n}\n.lms-sidenav.navbar-vertical.navbar-expand-xs .navbar-nav .nav-link {\n  margin: 0 14px;\n  padding: 9px 12px;\n  font-size: 13px;\n  font-weight: 400;\n  color: #b8bcc1;\n  border-radius: 6px;\n  line-height: 1.4;\n}\n.lms-sidenav.navbar-vertical .navbar-nav .nav-link:hover {\n  color: #fff;\n  background: #1b1e22;\n}\n.lms-sidenav.navbar-vertical .navbar-nav > .nav-item .nav-link.active {\n  color: #fff !important;\n  background: #ff4a17 !important;\n  font-weight: 500;\n  box-shadow: none;\n  border-radius: 6px;\n}\n.lms-sidenav .nav-link-text {\n  margin-left: 0 !important;\n}\n\n/* Sidebar section label */\n.lms-nav-section {\n  font-family: \"JetBrains Mono\", \"SFMono-Regular\", Consolas, monospace;\n  font-size: 10px;\n  letter-spacing: 0.14em;\n  color: #6b7178;\n  padding: 18px 26px 8px;\n  list-style: none;\n}\n\n/* Flat main area next to the LMS sidebar (no rounded corner / light gap) */\n.main-content.lms-main {\n  border-radius: 0;\n}\n.lms-shell {\n  background-color: #0b0c0e;\n}\n\n@media (max-width: 1200px) {\n  .lms-form-grid { grid-template-columns: 1fr; }\n}\n@media (max-width: 992px) {\n  .lms-stats { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n}\n@media (max-width: 576px) {\n  .lms-page { padding: 18px 16px 30px; }\n  .lms-stats { grid-template-columns: 1fr; }\n  .lms-form-row { grid-template-columns: 1fr; }\n  .lms-search { max-width: none; }\n}\n\n/* Refinements to match the design more closely */\n.lms-main label {\n  margin-left: 0;\n  font-size: inherit;\n}\n.lms-table th:first-child,\n.lms-table td:first-child { padding-left: 20px; }\n.lms-table th:last-child,\n.lms-table td:last-child { padding-right: 20px; }\n.lms-table td > .tone-green,\n.lms-table td > .tone-red,\n.lms-table td > .tone-amber { font-weight: 600; }\n\n.lms-select {\n  appearance: none;\n  -webkit-appearance: none;\n  padding-right: 34px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='5' viewBox='0 0 8 5'%3E%3Cpath fill='%239aa0a6' d='M0 0h8L4 5z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 14px center;\n  cursor: pointer;\n}\n.lms-select option { background: #16181b; color: #fff; }\n\n.lms-btn:disabled { opacity: 0.4; cursor: default; }\n.lms-pager { display: inline-flex; align-items: center; gap: 10px; }\n\n/* Sidebar logo: small and left aligned like the design */\n.sidenav.lms-sidenav .sidenav-header {\n  height: auto;\n  padding: 24px 26px 20px;\n}\n.sidenav.lms-sidenav .navbar-brand {\n  padding: 0;\n  text-align: left;\n}\n.navbar-vertical.lms-sidenav .navbar-brand-img {\n  height: 22px;\n  max-height: 22px;\n  width: auto;\n}\n.lms-main label.lms-label { font-size: 11px; }\n.lms-main label.lms-check { font-size: 13px; }\n.lms-table td .lms-btn-sm { padding: 5px 10px; }\n@media (max-width: 1400px) {\n  .lms-table th,\n  .lms-table td { padding-left: 12px; padding-right: 12px; }\n}\n\n/* Create class: field errors, student search results, selected students */\n.lms-field-error { color: #ff5a5a; font-size: 12px; margin-top: 6px; }\n.lms-link:disabled { opacity: 0.5; cursor: default; }\n.lms-results { margin-top: 6px; border: 1px solid #2f3439; border-radius: 8px; max-height: 220px; overflow-y: auto; }\n.lms-result {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 9px 12px;\n  background: none;\n  border: 0;\n  border-bottom: 1px solid #2a2e33;\n  color: #e9eaec;\n  font-size: 13px;\n  text-align: left;\n  cursor: pointer;\n}\n.lms-result:last-child { border-bottom: 0; }\n.lms-result:hover:not(:disabled) { background: #1b1e21; }\n.lms-result:disabled { cursor: default; opacity: 0.6; }\n.lms-student-chips { max-height: 160px; overflow-y: auto; margin: 10px 0 0; }\n.lms-conflict + .lms-conflict { margin-top: 8px; }\n\n/* Class detail: label / value rows in the side card */\n.lms-detail-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  padding: 9px 0;\n  border-bottom: 1px solid #2a2e33;\n  font-size: 13px;\n  color: #e9eaec;\n}\n.lms-detail-row:last-child { border-bottom: 0; }\n.lms-detail-row > span:first-child { color: #9aa0a6; }\n.lms-detail-row > span:last-child { text-align: right; }\n\n/* Confirm dialog (lmsConfirm): dark card on a dim overlay, replaces the white react-confirm-alert box */\n.react-confirm-alert-overlay.lms-confirm-overlay {\n  background: rgba(5, 6, 8, 0.72);\n  z-index: 2000;\n  padding: 16px;\n  animation: lms-fade-in 0.15s forwards;\n}\n.lms-confirm {\n  width: min(440px, calc(100vw - 32px));\n  background: #16181b;\n  border: 1px solid #2a2e33;\n  border-radius: 14px;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.55);\n  padding: 22px 22px 20px;\n  color: #e9eaec;\n  font-family: \"Inter\", -apple-system, \"Segoe UI\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  animation: lms-pop-in 0.18s ease-out;\n}\n.lms-confirm-title { font-size: 17px; font-weight: 600; color: #fff; margin: 0 0 14px; }\n.lms-confirm-summary {\n  background: #0f1113;\n  border: 1px solid #2a2e33;\n  border-radius: 10px;\n  padding: 12px 14px;\n  font-size: 14px;\n  margin-bottom: 12px;\n}\n.lms-confirm-text { font-size: 13px; line-height: 1.55; color: #9aa0a6; margin: 0 0 20px; }\n.lms-confirm-actions { display: flex; justify-content: flex-end; gap: 10px; flex-wrap: wrap; }\n.lms-btn-danger-fill { background: #e5484d; border-color: #e5484d; color: #fff; }\n.lms-btn-danger-fill:hover { background: #f05a5f; border-color: #f05a5f; color: #fff; }\n@keyframes lms-fade-in { from { opacity: 0; } to { opacity: 1; } }\n@keyframes lms-pop-in { from { opacity: 0; transform: translateY(6px) scale(0.98); } to { opacity: 1; transform: none; } }\n\n/* space between two cards stacked in one column */\n.lms-section-gap { height: 18px; }\n.lms-confirm-input { display: block; box-sizing: border-box; resize: vertical; min-height: 76px; margin: 0 0 18px; font-family: inherit; font-size: 13px; }\n\n/* Cancel a class dialog (confirmCancel in LmsClasses) */\n.lms-confirm.lms-cancel {\n  width: min(720px, calc(100vw - 32px));\n  max-height: calc(100vh - 32px);\n  overflow-y: auto;\n  padding: 28px 32px 24px;\n}\n.lms-cancel-head { display: flex; justify-content: space-between; align-items: flex-start; gap: 16px; margin-bottom: 24px; }\n.lms-cancel-title { font-size: 24px; font-weight: 700; color: #fff; margin: 0 0 4px; letter-spacing: -0.01em; }\n.lms-cancel-sub { font-size: 14px; color: #9aa0a6; margin: 0; }\n.lms-cancel-close {\n  background: none;\n  border: 0;\n  color: #9aa0a6;\n  font-size: 22px;\n  line-height: 1;\n  padding: 2px 4px;\n  cursor: pointer;\n}\n.lms-cancel-close:hover { color: #fff; }\n.lms-cancel .lms-form-row { margin-bottom: 22px; }\n.lms-cancel-value {\n  background: #0f1113;\n  border: 1px solid #2a2e33;\n  border-radius: 10px;\n  padding: 14px 16px;\n  font-size: 15px;\n  color: #fff;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.lms-cancel-section { margin-bottom: 22px; }\n.lms-cancel-reason { border-radius: 999px; padding: 9px 16px; }\n.lms-cancel-reason.active,\n.lms-cancel-reason.active:hover { background: #ff4a17; border-color: #ff4a17; color: #fff; }\n.lms-cancel-message {\n  display: block;\n  resize: vertical;\n  min-height: 130px;\n  border-radius: 10px;\n  padding: 14px 16px;\n  font-family: inherit;\n  font-size: 15px;\n}\n.lms-cancel-checks .lms-check { font-size: 15px; margin-bottom: 16px; }\n.lms-cancel-checks .lms-check input {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 22px;\n  height: 22px;\n  flex-shrink: 0;\n  background: #0f1113 center / 14px no-repeat;\n  border: 1px solid #3a3f45;\n  border-radius: 5px;\n  cursor: inherit;\n}\n.lms-cancel-checks .lms-check input:checked {\n  background-color: #ff4a17;\n  border-color: #ff4a17;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M3 8.5l3.2 3.2L13 4.8' fill='none' stroke='%23fff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n}\n.lms-cancel-checks .lms-check input:focus-visible { outline: 2px solid #ff4a17; outline-offset: 2px; }\n.lms-check-fixed { cursor: default; }\n.lms-check-fixed input { pointer-events: none; }\n.lms-check-tag {\n  margin-left: auto;\n  font-family: \"JetBrains Mono\", \"SFMono-Regular\", Consolas, monospace;\n  font-size: 11px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #6b7178;\n}\n.lms-cancel-foot {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n  border-top: 1px solid #2a2e33;\n  margin-top: 20px;\n  padding-top: 20px;\n}\n.lms-cancel-note { font-size: 13px; color: #9aa0a6; }\n.lms-cancel-foot .lms-btn { padding: 11px 20px; font-size: 15px; border-radius: 10px; }\n.lms-cancel-foot .lms-btn:disabled { opacity: 0.4; cursor: default; }\n\n/* Sub admins (LmsSubAdmins) */\n.lms-subadmin-search { display: block; width: 100%; box-sizing: border-box; }\n.lms-subadmin-results { display: flex; flex-direction: column; gap: 6px; margin-top: 10px; max-height: 240px; overflow-y: auto; }\n.lms-subadmin-result {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  text-align: left;\n  background: #0f1113;\n  border: 1px solid #2a2e33;\n  border-radius: 8px;\n  padding: 10px 12px;\n  color: #e9eaec;\n  cursor: pointer;\n}\n.lms-subadmin-result:hover { border-color: #ff4a17; }\n.lms-subadmin-sections { display: flex; gap: 6px; flex-wrap: wrap; }\n.lms-subadmin-sections .lms-chip { padding: 4px 10px; font-weight: 500; }\n/* section from a role (Roles screen), not editable here */\n.lms-subadmin-sections .lms-chip-role { background: transparent; border-style: dashed; color: #9aa0a6; }\n@media (max-width: 576px) {\n  .lms-confirm.lms-cancel { padding: 22px 18px 18px; }\n  .lms-cancel .lms-form-row { grid-template-columns: 1fr; }\n  .lms-cancel-foot .lms-confirm-actions { width: 100%; }\n  .lms-cancel-foot .lms-btn { flex: 1; }\n}\n\n/* Dashboard charts */\n.lms-charts {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 2fr);\n  gap: 14px;\n  margin-bottom: 18px;\n}\n.lms-chart-card { padding: 18px; overflow: visible; }\n.lms-chart-frame { position: relative; margin-top: 8px; }\n.lms-chart-overlay {\n  position: absolute;\n  inset: 0 0 24px 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 0 16px;\n  color: #9aa0a6;\n  font-size: 13px;\n  pointer-events: none;\n}\n.lms-chart-note { margin-top: 12px; text-align: center; font-size: 12px; color: #9aa0a6; }\n.lms-chart-empty {\n  min-height: 200px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #9aa0a6;\n  font-size: 13px;\n}\n.lms-donut { position: relative; margin-top: 8px; }\n.lms-donut-center {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n}\n.lms-donut-value { font-size: 26px; font-weight: 700; color: #fff; line-height: 1.1; }\n.lms-chart-legend {\n  list-style: none;\n  padding: 0;\n  margin: 12px 0 0;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 6px 18px;\n  font-size: 12px;\n  color: #b3b8bd;\n}\n.lms-chart-legend li { display: flex; align-items: center; gap: 6px; }\n.lms-chart-legend strong { color: #fff; }\n.lms-chart-swatch { width: 10px; height: 10px; border-radius: 2px; display: inline-block; flex-shrink: 0; }\n.lms-chart-tooltip {\n  background: #0f1113;\n  border: 1px solid #2a2e33;\n  border-radius: 8px;\n  padding: 8px 10px;\n  font-size: 12px;\n  color: #b3b8bd;\n}\n.lms-chart-tooltip-title { color: #fff; font-weight: 600; margin-bottom: 4px; }\n.lms-chart-tooltip-row { display: flex; align-items: center; gap: 6px; }\n.lms-chart-tooltip-row strong { color: #fff; margin-left: auto; padding-left: 12px; }\n\n@media (max-width: 991px) {\n  .lms-charts { grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); }\n  .lms-charts > :last-child { grid-column: 1 / -1; }\n}\n@media (max-width: 575px) {\n  .lms-charts { grid-template-columns: minmax(0, 1fr); }\n}\n\n.lms-week-card { margin-bottom: 18px; }\n.lms-chart-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n.lms-week-nav { display: flex; gap: 6px; }\n\n/* Check-in location dialog (LmsLocation) */\n.lms-confirm.lms-location { width: min(640px, calc(100vw - 32px)); }\n.lms-location-sub { margin-bottom: 12px; }\n.lms-location-map { display: block; width: 100%; height: 340px; border: 1px solid #2a2e33; border-radius: 10px; background: #0f1113; }\n.lms-location-meta { display: flex; justify-content: space-between; gap: 10px; flex-wrap: wrap; font-size: 12px; color: #9aa0a6; margin: 10px 0 18px; }\n.lms-location-link { display: block; margin-top: 2px; }\n.lms-location-name { font-size: 13px; color: #e8eaed; line-height: 1.4; margin: 0 0 12px; }\n.lms-location-place { max-width: 240px; margin-top: 2px; white-space: normal; line-height: 1.35; }\n\n/* react-datepicker (Create / Edit class date) in the dark theme */\n.lms-main .react-datepicker-wrapper { display: block; width: 100%; }\n.lms-datepicker.react-datepicker {\n  background: #16181b;\n  border: 1px solid #2f3439;\n  border-radius: 10px;\n  color: #e9eaec;\n  font-family: inherit;\n  font-size: 13px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);\n}\n.lms-datepicker .react-datepicker__header {\n  background: #1d2024;\n  border-bottom: 1px solid #2f3439;\n  border-top-left-radius: 10px;\n}\n.lms-datepicker .react-datepicker__current-month,\n.lms-datepicker .react-datepicker__day-name { color: #e9eaec; }\n.lms-datepicker .react-datepicker__day { color: #e9eaec; border-radius: 6px; }\n.lms-datepicker .react-datepicker__day:hover { background: #2a2e33; }\n.lms-datepicker .react-datepicker__day--outside-month { color: #555b62; }\n.lms-datepicker .react-datepicker__day--today { font-weight: 700; color: #ff4a17; }\n.lms-datepicker .react-datepicker__day--selected,\n.lms-datepicker .react-datepicker__day--keyboard-selected { background: #ff4a17; color: #fff; }\n.lms-datepicker .react-datepicker__navigation-icon::before { border-color: #9aa0a6; }\n.lms-datepicker .react-datepicker__today-button {\n  background: #1d2024;\n  border-top: 1px solid #2f3439;\n  color: #e9eaec;\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n}\n.react-datepicker-popper:has(.lms-datepicker) .react-datepicker__triangle { display: none; }\n.react-datepicker-popper:has(.lms-datepicker) { z-index: 20; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
